<template>
	<ViewUiCalloutIcon
		class="view-ui-state-nofavorites"
		iconFilename="heart-fill.svg"
		v-bind:message="'Your favorite venues<br />will appear here'"
	/>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Ui/State
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUiStateNoFavorites extends ViewBase {
		// Not implemented
	}
</script>

<style lang="scss">
	.view-ui-state-nofavorites {
		aspect-ratio: auto;
		margin: 0;
	}
</style>
